import Big from "big.js";

import { InnerQueryExpression } from "../InnerQueryExpression";

export class DecimalConstantExpression implements InnerQueryExpression {
    public readonly $discriminator = "DecimalConstant";
    public readonly value: string;

    public constructor(value: number | Big) {
        this.value = value instanceof Big ? value.toFixed() : value.toString();
    }
}
